/**
 * Stable key of the platform-level "Trial Membership Activated At" custom
 * attribute on Address (1V-5895). A non-empty value means the site already
 * used its one-time trial membership: the backend rejects further
 * activations, the portal hides the action, and the Trial Eligible support
 * policy stops matching.
 *
 * The only other declaration is the SQL seed in
 * packages/db/dml/custom_attribute_definition, which cannot import this
 * constant - keep them byte-identical.
 */
export const TRIAL_MEMBERSHIP_ACTIVATED_AT_KEY = 'ca_11421408ed5f41f7ad28d669854e32e5';
